module.exports = __webpack_public_path__ + "static/media/training_seashell_mind_body_fitness.8594a629.webp";